import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Import icons for arrow
import Section from "../../components/Section";
import Heading from "../../components/Heading";

const faqData = [
  {
    question: "How does BafarAgent improve customer communication?",
    answer:
      "BafarAgent leverages AI to automate customer interactions, ensuring quick, accurate responses to inquiries, appointment scheduling, and support requests, all while maintaining a personal touch.",
  },
  {
    question: "Can BafarAgent be used for lead generation?",
    answer:
      "Yes, BafarAgent is designed to assist in lead generation by engaging potential customers, collecting their information, and scheduling follow-ups—all automated to boost your sales funnel efficiency.",
  },
  {
    question: "What industries can benefit from BafarAgent?",
    answer:
      "BafarAgent is adaptable to various industries including retail, healthcare, real estate, e-commerce, and finance. It streamlines customer engagement, support, and service across all sectors.",
  },
  {
    question: "Is BafarAgent suitable for handling large call volumes?",
    answer:
      "Absolutely! BafarAgent is scalable and can handle thousands of customer interactions simultaneously, ensuring no calls are missed, especially during high-demand periods.",
  },
  {
    question: "Can BafarAgent provide multilingual support?",
    answer:
      "Yes, BafarAgent supports multiple languages, allowing businesses to offer seamless communication with a global customer base, improving accessibility and customer experience.",
  },
  {
    question: "How does BafarAgent ensure data security?",
    answer:
      "BafarAgent follows industry best practices for data security, ensuring all customer interactions are encrypted, compliant with regulations, and protected from unauthorized access.",
  },
  {
    question: "Can I customize the scripts used by BafarAgent?",
    answer:
      "Yes, BafarAgent allows full customization of conversation scripts, ensuring the AI agents align with your business tone, policies, and customer needs.",
  },
  {
    question: "Does BafarAgent integrate with CRM systems?",
    answer:
      "Yes, BafarAgent can seamlessly integrate with various CRM platforms, allowing for a smooth workflow, tracking interactions, and maintaining up-to-date customer information.",
  },
  {
    question: "How can I monitor BafarAgent’s performance?",
    answer:
      "BafarAgent offers real-time analytics and reporting tools, providing insights into call volume, customer satisfaction, response times, and overall system performance.",
  },
  {
    question: "Is there a mobile app for BafarAgent?",
    answer:
      "Currently, BafarAgent is a cloud-based platform that works across devices. A mobile app is in development and will be available soon for more flexibility.",
  },
  {
    question: "How do I get started with BafarAgent?",
    answer:
      "Getting started is easy! Sign up for a free demo on our website, and our team will guide you through the setup process to integrate BafarAgent into your business.",
  },
];

const AiFaq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle the open/close state of the clicked item
  };

  return (
    <Section crosses>
      <Heading
        title="Frequently Asked Questions"
        headingclassName="!text-4xl font-semibold text-nowrap"
        text="Find answers to common questions about how BafarAgent’s AI voice agents can optimize customer service, enhance communication, and boost operational efficiency."
        textclassName="!text-slate-300 !mt-10"
      />

      <section className="container mb-16 py-10" id="faq_tab">
        <div className="mx-auto px-6">
          <>
            {faqData.map((faq, index) => (
              <div key={index} className="opacity-90">
                {/* Unified Container for Question and Answer */}
                <div
                  className={`border-b border-gray-800 py-3 transition-all duration-300 ease-in-out`}
                >
                  <button
                    onClick={() => handleToggle(index)}
                    className="flex w-full items-center justify-between p-4 text-left font-semibold text-white"
                  >
                    <span>{faq.question}</span>
                    <span
                      className={`transform transition-transform duration-300 ${
                        openIndex === index ? "rotate-180" : ""
                      }`}
                    >
                      {openIndex === index ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </span>
                  </button>

                  {/* Answer Section with Smooth Transition */}
                  <div
                    className={`transition-max-height overflow-hidden duration-500 ease-in-out ${
                      openIndex === index
                        ? "max-h-[1000px] py-4"
                        : "max-h-0 py-0"
                    }`}
                  >
                    <p className="px-6 text-slate-300">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </>
        </div>
      </section>
    </Section>
  );
};

export default AiFaq;
